import { ApiRequest } from '../api/request';
import { ENVIRONMENTS } from './env.constants';
import _ from 'lodash';

export default class ConfigService extends ApiRequest {
  constructor($http, $q, appCache) {
    'ngInject';
    super({ $http, $q, appCache });
  }

  storeConfig(config) {
    this.appCache.set('config', config);
  }

  getConfig() {
    return this.appCache.get('config');
  }

  fetchLegalContent(tenant, document) {
    const loweredKebab = _.kebabCase(tenant);

    return this.$http({
      url: `https://tenants.fino.cloud/conf/dws/${loweredKebab}/${document}`,
    });
  }

  get config() {
    return this.getConfig();
  }

  getStage() {
    // eslint-disable-next-line angular/window-service
    const host = window.location.host;
    if (host.includes('localhost') || host.includes('.dev')) {
      return ENVIRONMENTS.DEV;
    } else if (host.includes('.test')) {
      return ENVIRONMENTS.TESTING;
    } else {
      return ENVIRONMENTS.PRODUCTION;
    }
  }

  isDevelopment() {
    return this.getStage() === ENVIRONMENTS.DEV;
  }

  isTesting() {
    return this.getStage() === ENVIRONMENTS.TESTING;
  }

  isProduction() {
    return this.getStage() === ENVIRONMENTS.PRODUCTION;
  }

  getName() {
    if (!this.config) return null;
    return this.config.name;
  }

  getTenant() {
    if (!this.config) return null;
    return this.config.tenant;
  }

  isFeatureActive(feature) {
    return !!this.getFeature(feature);
  }

  getFeature(feature) {
    if (!this.config) return false;
    return this.config.features[feature];
  }

  $get() {
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/config/config.service.js